import { createSlice } from "@reduxjs/toolkit";
import { CollectionUtils } from "../../utils/collectionUtils/collectionUtils";
import { Api } from "../../api/api";

const leftPanelSlice = createSlice({
  name: "leftPanel",
  initialState: {
    collections: [],
    selectedCollection: {
      common: true,
      created_at: "2021-04-14T11:55:14",
      id: "6076d822207cbf1435820d2a",
      name: "Bloomberg",
      type: "collection",
    },
    sorting: "Market Cap",
    filters: [],
    searchValue: "",
    unsortedCharts: [],
    sortedCharts: [],
    currencyFilteredCharts: [],
    chartListData: [],
  },
  reducers: {
    setCollections: (state, action) => {
      state.collections = action.payload;
    },
    setSelectedCollection: (state, action) => {
      state.selectedCollection = action.payload;
    },
    setSorting: (state, action) => {
      state.sorting = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    setUnsortedCharts: (state, action) => {
      state.unsortedCharts = action.payload;
    },
    setSortedCharts: (state, action) => {
      state.sortedCharts = action.payload;
    },
    setCurrencyFilteredCharts: (state, action) => {
      state.currencyFilteredCharts = action.payload;
    },
    setChartListData: (state, action) => {
      state.chartListData = action.payload;
    },
  },
});

export default leftPanelSlice.reducer;

export const {
  setCollections,
  setSelectedCollection,
  setSorting,
  setFilters,
  setSearchValue,
  setUnsortedCharts,
  setSortedCharts,
  setCurrencyFilteredCharts,
  setChartListData,
} = leftPanelSlice.actions;

//Chain as follows:
//get collectionlist => get chart list => sort list => filter by currency => filter by search value => return
export const getCollectionList = () => async (dispatch) => {
  const collectionList = await CollectionUtils.getChartCollections();
  dispatch(setCollections(collectionList));
  dispatch(setSelectedCollection(collectionList[0]));
  dispatch(getChartList());
};

export const getChartList = () => async (dispatch, getState) => {
  const collection = getState().leftPanel.selectedCollection;
  //reset list while we wait for the new one
  dispatch(setChartListData([]));

  const chartList = await CollectionUtils.getChartList(collection);
  dispatch(setUnsortedCharts(chartList));
  await dispatch(getSortedCharts());
};

export const getSortedCharts = () => async (dispatch, getState) => {
  const sorting = getState().leftPanel.sorting;
  const unsortedCharts = getState().leftPanel.unsortedCharts;

  const sortedCharts = CollectionUtils.sortCharts(unsortedCharts, sorting);
  dispatch(setSortedCharts(sortedCharts));
  return await dispatch(getCurrencyFilteredCharts());
};

export const getCurrencyFilteredCharts = () => async (dispatch, getState) => {
  const filters = getState().leftPanel.filters;
  const sortedCharts = getState().leftPanel.sortedCharts;

  const currencyFilteredCharts = CollectionUtils.filterNamesByFilterArray(
    sortedCharts,
    filters
  );
  dispatch(setCurrencyFilteredCharts(currencyFilteredCharts));
  return await dispatch(getSearchFilteredCharts());
};

export const getSearchFilteredCharts = () => async (dispatch, getState) => {
  const searchValue = getState().leftPanel.searchValue;
  const currencyFilteredCharts = getState().leftPanel.currencyFilteredCharts;

  const searchFilteredCharts = CollectionUtils.filterNamesByText(
    currencyFilteredCharts,
    searchValue
  );
  dispatch(setChartListData(searchFilteredCharts));
};

//Training chart actions

export const uploadChart = (data) => async (dispatch, getState) => {
  const collection = getState().leftPanel.selectedCollection;
  const response = await Api.uploadNewChart(data);
  if (response.id && collection.type === "training") {
    dispatch(getChartList());
  }
  return response;
};
export const deleteChart = (id) => async (dispatch, getState) => {
  const collection = getState().leftPanel.selectedCollection;
  const response = await Api.deleteChart(id);
  if (response && collection.type === "training") {
    dispatch(getChartList());
  }
  return response;
};

export const refreshCollection = (id) => (dispatch, getState) => {
  const selectedCollection =
    getState().customCollections.data.find(
      (customCollection) => customCollection.id === id
    ) ||
    getState().leftPanel.collections.find((collection) => collection.id === id);

  if (!selectedCollection) return;

  dispatch(setSelectedCollection(selectedCollection));
  dispatch(getChartList());
};
